import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

import { setModalLoading } from "../../actions/loading";

// import assets
import LogoFullSrc from "../../brand/logo-full.png";

const Header = ({ theme, onToggleTheme }) => {
  const location = useLocation();

  const firstpath = location.pathname?.split("/")[1];

  const [navOpen, setNavOpen] = useState(false);

  const dispatch = useDispatch();

  const handleBookInterview = () => {
    dispatch(setModalLoading(true));
  };

  return (
    <header className="site-header">
      <a
        className="brand active"
        href="/"
        data-discover="true"
        aria-current="page"
      >
        <img className="logo-full" alt="Lovapex Tech logo" src={LogoFullSrc} />
      </a>
      <button
        className="icon-button menu-button"
        type="button"
        onClick={() => setNavOpen(!navOpen)}
      >
        Menu
      </button>
      <nav className={`nav ${navOpen ? "open" : ""}`}>
        <a
          className={firstpath === "" ? "active" : ""}
          href="/"
          data-discover="true"
          aria-current="page"
        >
          Home
        </a>
        <a
          className={firstpath === "about" ? "active" : ""}
          href="/about"
          data-discover="true"
        >
          About
        </a>
        <a
          className={firstpath === "careers" ? "active" : ""}
          href="/careers"
          data-discover="true"
        >
          Careers
        </a>
        <a
          className={firstpath === "product" ? "active" : ""}
          href="/product"
          data-discover="true"
        >
          Product
        </a>
        <a
          className={firstpath === "contact" ? "active" : ""}
          href="/contact"
          data-discover="true"
        >
          Contact
        </a>
        <a
          className={firstpath === "login" ? "active" : ""}
          href="/login"
          data-discover="true"
        >
          Login
        </a>
      </nav>
      <button
        className="theme-toggle"
        type="button"
        onClick={onToggleTheme}
        aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
        title={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
      >
        {theme === "dark" ? (
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="12" cy="12" r="4" />
            <path d="M12 2v2M12 20v2M4.93 4.93l1.42 1.42M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.42-1.42M17.66 6.34l1.41-1.41" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M20.4 15.4A8.5 8.5 0 0 1 8.6 3.6 8.5 8.5 0 1 0 20.4 15.4Z" />
          </svg>
        )}
        <span>{theme === "dark" ? "Light" : "Dark"}</span>
      </button>
      <button
        className="button button-primary button-md header-cta"
        onClick={() => handleBookInterview()}
      >
        Book a Free Strategic Consultation
      </button>
    </header>
  );
};

export default Header;
